import axios from "axios";
import {
  FETCH_BREEDERS,
  FETCH_BREEDS_CATEGORY,
  ADD_SIGNATURE,
  interceptor,
  ADD_BREEDER,
  FETCH_BREEDERS_VACCINE_DURATION,
  FETCH_BREEDER_BY_ID,
  FETCH_BREEDER_INFO,
  ADD_BREEDER_VACCINE,
  UPDATE_BREEDER,
  DELETE_BREEDER_VACCINE,
  CREATED_BREEDER_VACCINE,
  DELETE_BREEDER,
  FETCH_CURRENT_USER_SETTING,
  BREEDERS_SEARCH_VIA_BREEDTYPE,
  FETCH_BREEDERS_APPLICATIONS,
  CREATE_BREEDER_APPLICATION,
  GET_BREEDER_APPLICATION,
  CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION,
} from ".";
// import { BASE_URL } from "../utils/helper";

import store from "../store";

interceptor(axios, store);
export function fetchBreeders() {
  return {
    type: FETCH_BREEDERS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function attachSignature(id, logo) {
  const config = {
    headers: {
      "content-type": undefined,
      Authorization: store.getState().cognito.token,
      PetShopId: store.getState().petShopReducer.currentPetshop.id
    }
  };

  return {
    type: ADD_SIGNATURE,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/breeder/attachSignature/${id}`,
      logo,
      config
    )
  };
}


export function fetchBreedCategory() {
  return {
    type: FETCH_BREEDS_CATEGORY,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/getBreedCategory`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}


export function fetchBreederDurartion() {
  return {
    type: FETCH_BREEDERS_VACCINE_DURATION,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/automatic_vaccine/getBreederDurartion`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function addBreeder(breeder) {
  return {
    type: ADD_BREEDER,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/`, breeder, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchBreederById(id) {
  return {
    type: FETCH_BREEDER_BY_ID,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchBreederInfo(id) {
  return {
    type: FETCH_BREEDER_INFO,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function addBreederVaccine(vaccines) {
  return {
    type: ADD_BREEDER_VACCINE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/breedervaccine`, vaccines, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateBreeder(id,breeder){
  return {
    type: UPDATE_BREEDER,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/${id}`, breeder, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteBreederVaccine(id){
  return {
    type: DELETE_BREEDER_VACCINE,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/breedervaccine/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function createdBreederVaccine(breeder) {
  return {
    type: CREATED_BREEDER_VACCINE,
    payload: breeder
  }
}

export function deleteBreeder(id) {
  return {
    type: DELETE_BREEDER,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/deleteBreeder`,id ,{
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchCurrentUserForSetting(un) {
  return {
    type: FETCH_CURRENT_USER_SETTING,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/user/getUserByUsername/${un}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getBreedersViaBreedType(breedTypeId) {
    return {
      type: BREEDERS_SEARCH_VIA_BREEDTYPE,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/breederSearch/viaBreed/${breedTypeId}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
  };
}

export function getBreedersApplicationList() {
    return {
      type: FETCH_BREEDERS_APPLICATIONS,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/fetchBreederApplications`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
  };
}

export function createBreederApplication(data) {
  return {
    type: CREATE_BREEDER_APPLICATION,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/breederApplication/create`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
};
}

export function showBreedersApplication(id) {
  return {
    type: GET_BREEDER_APPLICATION,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/getBreederApplication/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
};
}

export function changeApprovalStatus(id,data) {
  return {
    type: CHANGE_APPROVAL_STATUS_BREEDER_APPLICATION,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/breeder/changeApplicationStatus/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
};
}